import { LitElement, PropertyValues, TemplateResult, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

const ICON_SIZE_DEFAULT = '24px';
@customElement('app-icon')
export class IconComponent extends LitElement {
    @property({ type: String }) k_size: string = ICON_SIZE_DEFAULT;
    @property({ type: String }) k_color: string | null = null;
    @property({ type: String, reflect: false }) k_svg: string; // SVG raw o URL

    static styles = css`
        :host {
            display: inline-flex;
            vertical-align: middle;
        }
        span {
            display: contents;
        }
        svg {
            width: var(--icon-size, 24px);
            height: var(--icon-size, 24px);
            fill: var(--icon-color, gray);
            display: block;

            >path {
                fill: var(--icon-color, gray);
            }
        }
        img {
            width: var(--icon-size, 24px);
            height: var(--icon-size, 24px);
            display: block;
        }
        ::slotted(svg),
        ::slotted(img) {
            width: var(--icon-size, 24px);
            height: var(--icon-size, 24px);
            fill: var(--icon-color, gray);
            display: block;
        }
    `;

    // **********************************************************************
    // Ciclo de vida del componente
    // **********************************************************************

    render() {
        return html`
            <span style="--icon-size: ${this.k_size};">
                <slot @slotchange=${this.handleSlotChange}></slot>
                ${this.renderFallbackIcon()}
            </span>
        `;
    }

    protected updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);

        if (changedProperties.has('k_color')) {
            if (this.k_color) {
                this.style.setProperty('--icon-color', this.k_color);
            } else {
                this.style.removeProperty('--icon-color');
            }
        }
    }

    private handleSlotChange(event: Event) {
        const slot = event.target as HTMLSlotElement;
        const assignedNodes = slot.assignedNodes({ flatten: true });
        const hasSvgOrImg = assignedNodes.some(
            (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                (node as HTMLElement).tagName?.toLowerCase() === 'svg' ||
                (node as HTMLElement).tagName?.toLowerCase() === 'img'
        );

        if (!hasSvgOrImg) {
            this.style.display = 'none';
        }
    }

    private renderFallbackIcon(): TemplateResult {
        if (this.k_svg) {
            const isSvgRaw = /<svg[\s\S]*?>[\s\S]*?<\/svg>/i.test(this.k_svg.trim()); // Verifica si contiene una estructura SVG válida

            if (isSvgRaw) {
                return html`${unsafeHTML(this.k_svg)}`;
            } else {
                // URL
                return html`<img src="${this.k_svg}" alt="icon" />`;
            }
        }
        return null;
    }
}
